import {
  Directive,
  ElementRef,
  inject,
  input,
  OnDestroy,
  output,
} from '@angular/core';

@Directive({
  selector: '[appLabelOverflow]',
  standalone: true,
})
export class LabelOverflowDirective implements OnDestroy {
  private readonly element = inject<ElementRef<HTMLElement>>(ElementRef);

  readonly expanded = input<boolean>(false);
  readonly overflowChange = output<boolean>();

  private readonly observer = new ResizeObserver(() => this.check());

  constructor() {
    this.observer.observe(this.element.nativeElement);
  }

  ngOnDestroy(): void {
    this.observer.disconnect();
  }

  private check(): void {
    if (this.expanded()) {
      return;
    }
    const el = this.element.nativeElement;
    this.overflowChange.emit(el.scrollWidth > el.clientWidth);
  }
}
